import React, { useEffect, useState }  from 'react';
import '../../styles/notificationPage.scss'
import NotificationBgSvg from './NotificationBgSvg';
import FilterBlock from './filter/FilterBlock';
import GlowNotif from './GlowNotif';
import NotificationItem from './NotificationItem';

const NotificationPage = () => {

    const [notiArr, setNotifArr] = useState([
        {
            iconNotif:'notif1.svg',
            colorNotif:'yelow',
            iconUser:'user1.png',
            infoH3:'[Mooncatz] Meow has changed Anti-Webhook settings',
            infoText: '22/04/2023 at 15:53',
            lable:[
                'Anti-Webhook',

            ],
            textDrop:'<p>When setting up Anti-Spam feature, you have not selected any parameter, making the feature idling. In order for Themis to be able to track and prevent spam activity, please ensure that you selected at least one parameter. If you have any questions,<span> please contact support.</span></p>'
        },
        {
            iconNotif:'notif1.svg',
            colorNotif:'yelow',
            iconUser:'bot.png',
            infoH3:'[Divine Anarchy] Anti-Webhook has not been set up properly',
            infoText: '22/04/2023 at 15:53',
            lable:[
                'Anti-Webhook',
                'MinorError',
            ],
            textDrop:'<p>When setting up Anti-Spam feature, you have not selected any parameter, making the feature idling. In order for Themis to be able to track and prevent spam activity, please ensure that you selected at least one parameter. If you have any questions,<span> please contact support.</span></p>'
        },
        {
            iconNotif:'notif2.svg',
            colorNotif:'pink',
            iconUser:'bot.png',
            infoH3:'[UNIOVERSE] Anti-Spam does not work correctly ',
            infoText: '22/04/2023 at 15:53',
            lable:[
                // 'Anti-Webhook',
                // 'Minor Error',
                'MajorError',
                'Anti-Spam',
                // 'Admin',
                // 'Verification'
            ],
            textDrop:'<p>When setting up Anti-Spam feature, you have not selected any parameter, making the feature idling. In order for Themis to be able to track and prevent spam activity, please ensure that you selected at least one parameter. If you have any questions,<span> please contact support.</span></p>'
        },
        {
            iconNotif:'notif3.svg',
            colorNotif:'turquoise',
            iconUser:'user2.png',
            infoH3:'[Divine Anarchy] Administrator has changed Verification settings',
            infoText: '15/03/2023 at 09:31',
            lable:[
                // 'Anti-Webhook',
                // 'Minor Error',
                // 'Major Error',
                // 'Anti-Spam',
                'Admin',
                'Verification'
            ],
            textDrop:'<p>When setting up Anti-Spam feature, you have not selected any parameter, making the feature idling. In order for Themis to be able to track and prevent spam activity, please ensure that you selected at least one parameter. If you have any questions,<span> please contact support.</span></p>'
        },
        {
            iconNotif:'notif4.svg',
            colorNotif:'pink',
            iconUser:'user3.png',
            infoH3:'[Divine Anarchy] Andre removed Themis from the server ',
            infoText: '15/03/2023 at 09:31',
            lable:[
                'Themis',
            ],
            textDrop:'<p>When setting up Anti-Spam feature, you have not selected any parameter, making the feature idling. In order for Themis to be able to track and prevent spam activity, please ensure that you selected at least one parameter. If you have any questions,<span> please contact support.</span></p>'
        },
    ])
    return (
        <div className='notification_wrap'>
            <div className='notification_wrap_content'>
                <div className='notification_wrap_content_header'>
                    <h2>Global Notifications</h2>
                </div>
                <div className='notification_wrap_content_body'>
                    <div className='filters_wrap'>
                        <FilterBlock/>
                    </div>
                    <div className='notification_wrap_tab_bg'> 
                        <button className='notification_wrap_tab'>Notifications</button>
                    </div>
                    <div className='notification_wrap-bg'>
                        <div className='notification_wrap-bg_blur'></div>
                    </div>
                    <div className='notification_wrap_content_main'> 
                    {notiArr.map((item,idx) => (
                        <NotificationItem
                        idx={idx}
                        item = {item}
                        />
                    ))}

                    </div>
                </div>
            </div>
        </div>
    );
};

export default NotificationPage;